export const headerContent = {
    es: {
        navLinks: [
            { label: 'Contenido', href: '#films' },
            { label: 'Deporte', href: '#sports' },
            { label: 'Dispositivos', href: '#device' },
            { label: 'Precios', href: '#services' },
            { label: 'FAQ', href: '#faq' },
        ],
        callLabel: (phone) => `Llamar al ${phone}`,
        emailLabel: 'Enviar un email',
        whatsappLabel: 'Contactar por WhatsApp',
        offersCta: 'Ver las ofertas',
        openMenu: 'Abrir el menú',
        closeMenu: 'Cerrar el menú',
        emailShort: 'Email',
        whatsappShort: 'WhatsApp',
    },
};
